import { createElement } from 'react';
import {
  createBrowserRouter,
  createRoutesFromElements,
  Route,
} from 'react-router-dom';
import { privateRoutes, publicRoutes } from 'routes/constants';
import MainLayout from 'layouts/MainLayout/MainLayout';
import { lazyImport } from 'routes/helpers';
import PrivateRoute from 'routes/PrivateRoute';
import NotFoundPage from 'modules/Miscellaneous/NotFoundPage';
import ErrorBoundary from 'components/ErrorBoundary';
import { getPath } from 'routes/router-paths';

const AppRouterConfig = createBrowserRouter(
  createRoutesFromElements(
    <>
      {publicRoutes.map(route => (
        <Route
          key={route.path}
          path={route.path}
          element={route.element}
          errorElement={<ErrorBoundary />}
        />
      ))}

      <Route
        path={getPath('portalPage')}
        element={createElement(
          lazyImport(() => import('modules/Miscellaneous/PortalPage'))
        )}
        errorElement={<ErrorBoundary />}
      />

      <Route path="/" element={<MainLayout />}>
        {privateRoutes.map(route => (
          <Route
            key={route.path}
            path={route.path}
            element={<PrivateRoute>{route.element}</PrivateRoute>}
            errorElement={<ErrorBoundary />}
          />
        ))}
      </Route>
      <Route path="*" element={<NotFoundPage />} />
    </>
  )
);

export default AppRouterConfig;
